import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table } from 'antd'
const { WizSpin, WizButton, WizCard, WizModal, WizModalForm, WizBrowserExport } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../header'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/postPersonnel') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('antecedentInterventionPostPersonnel', record)
        } else {
            record = Session.get('antecedentInterventionPostPersonnel') || {}
        }
    }
    return record
}

class PostPersonnel extends WizContainer {

    componentName = 'PostPersonnel'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record,
            data: [],
            visible: false,
            formRecord: null
        }
    }

    _componentDidMount() {
        this._list()
    }

    _list = () => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/postPersonnel',
            payload: {
                key: 'postPersonnel@' + processContentId,
                apiParams: {
                    tutorContentId: processContentId
                }
            }
        })
    }

    _onBtn = (type) => {
        let { record, data } = this.state
        const { processContentId } = record
        switch (type) {
            case 'renew':
                this.doAction({
                    path: 'counselingProcess/renewPostPersonnel',
                    payload: {
                        key: 'renewPostPersonnel@' + processContentId,
                        apiParams: {
                            tutorContentId: processContentId
                        }
                    }
                })
                break
            case 'confirm':
                WizModal.confirm({
                    title: '注意',
                    content: '是否确认进行达标确认操作？',
                    onOk: () => {
                        this.doAction({
                            path: 'counselingProcess/confirmMainPerson',
                            payload: {
                                key: 'confirmMainPerson@' + processContentId,
                                apiParams: {
                                    tutorContentId: processContentId
                                }
                            }
                        })
                    },
                    onCancel() {
                    }
                })
                break
            case 'export':
                let columns = [{
                    headerName: '',
                    width: 30,
                    field: 'rowIndex',
                    hidden: true,
                    suppressMovable: true,
                    cellStyle: {
                        textAlign: 'center',
                        padding: '5px 0',
                        color: '#595959',
                        backgroundColor: '#f0f0f0',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: '500',
                        boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
                    }
                }, {
                    headerName: '岗位',
                    field: 'positionName',
                    width: 20,
                    cellStyle: { textAlign: 'left' },
                    style: { alignment: { vertical: 'middle', horizontal: 'center' } }
                }, {
                    headerName: '姓名',
                    field: 'fullName',
                    width: 20,
                    cellStyle: { textAlign: 'left' },
                    style: { alignment: { vertical: 'middle', horizontal: 'center' } }
                }, {
                    headerName: '账号',
                    field: 'userName',
                    width: 30,
                    cellStyle: { textAlign: 'left' },
                    style: { alignment: { vertical: 'middle', horizontal: 'center' } }
                // }, {
                //     headerName: '培训进度',
                //     field: 'trainingProgress',
                //     width: 20,
                //     cellStyle: { textAlign: 'left' },
                //     style: { alignment: { vertical: 'middle', horizontal: 'center' } }
                }, {
                    headerName: '状态',
                    field: 'trainingSituation',
                    width: 20,
                    cellStyle: { textAlign: 'left' },
                    style: { alignment: { vertical: 'middle', horizontal: 'center' } }
                }, {
                    headerName: '手机号',
                    field: 'mobile',
                    width: 30,
                    cellStyle: { textAlign: 'left' },
                    style: { alignment: { vertical: 'middle', horizontal: 'center' } }
                }, {
                    headerName: '电子邮箱',
                    field: 'email',
                    width: 30,
                    cellStyle: { textAlign: 'left' },
                    style: { alignment: { vertical: 'middle', horizontal: 'center' } }
                }, {
                    headerName: '备注',
                    field: 'mark',
                    width: 30,
                    cellStyle: { textAlign: 'left' },
                    style: { alignment: { vertical: 'middle', horizontal: 'center' } }
                }]

                let rows = data.map(item => {
                    let { trainingSituation } = item
                    item.trainingSituation = trainingSituation === 0 ? '合格' : '不合格'
                    return item
                })

                WizBrowserExport({
                    title: '主要岗位人员情况',
                    sheetName: '主要岗位人员情况',
                    columns: columns.filter((_, index) => index),
                    rows,
                    filename: '主要岗位人员情况.xlsx',
                })
                break
        }
    }

    _submit = (values = {}) => {
        const { processContentId } = this.state.record
        let { id, mark } = values
        let params = {
            id,
            mark,
            tutorContentId: processContentId
        }
        this.doAction({
            path: 'counselingProcess/writeMark',
            payload: {
                key: 'writeMark@' + processContentId,
                apiParams: params
            }
        })
    }

    propsAndStateOnChange = {
        list: this._listOnChange.bind(this),
        renew: this._renewOnChange.bind(this),
        writeMark: this._writeMarkOnChange.bind(this),
        confirm: this._confirmOnChange.bind(this),
    }

    _listOnChange(nextProps, nextState) {
        if (nextProps.list && nextProps.list.code === 1) {
            nextState.data = nextProps.list.data || []
        } else {
            wizNotice.error(nextProps.list.msg)
        }
        return true
    }

    _renewOnChange(nextProps, nextState) {
        if (nextProps.renew && nextProps.renew.code === 1) {
            nextState.data = nextProps.renew.data || []
        } else {
            wizNotice.error(nextProps.renew.msg)
        }
        return true
    }

    _writeMarkOnChange(nextProps, nextState) {
        if (nextProps.writeMark && nextProps.writeMark.code === 1) {
            nextState.visible = false
            nextState.formRecord = null
            this._list()
        } else {
            wizNotice.error(nextProps.writeMark.msg)
        }
        return true
    }

    _confirmOnChange(nextProps, nextState) {
        if (nextProps.confirm && nextProps.confirm.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.confirm.msg)
        }
        return true
    }

    _onWriteMark = (formRecord) => {
        this.setState({ visible: true, formRecord })
    }

    render() {
        let { record, data, visible, formRecord } = this.state
        let { processContentState } = record
        let { counselingProcessLoading } = this.props
        let columns = [{
            title: '岗位',
            name: 'positionName',
            dataIndex: 'positionName'
        }, {
            title: '姓名',
            name: 'fullName',
            dataIndex: 'fullName',
            formItem: {
                disabled: true
            }
        }, {
            title: '账号',
            name: 'userName',
            dataIndex: 'userName',
            formItem: {
                disabled: true
            }
        // }, {
        //     title: '培训进度',
        //     name: 'trainingProgress',
        //     dataIndex: 'trainingProgress'
        }, {
            title: '状态',
            name: 'trainingSituation',
            dataIndex: 'trainingSituation',
            render: (v) => {
                return v === 0 ? '合格' : '不合格'
            }
        }, {
            title: '手机号',
            name: 'mobile',
            dataIndex: 'mobile'
        }, {
            title: '电子邮箱',
            name: 'email',
            dataIndex: 'email'
        }, {
            title: '备注',
            name: 'mark',
            dataIndex: 'mark',
            formItem: {
                type: 'textarea',
                maxLength: 20
            }
        }, {
            title: '操作',
            name: 'operation',
            dataIndex: 'operation',
            align: 'center',
            width: 120,
            render: (v, r, i) => {
                let buttonProps = {
                    type: 'link',
                    disabled: processContentState === 1,
                    onClick: () => this._onWriteMark(r)
                }
                return <WizButton {...buttonProps}>{'填写备注'}</WizButton>
            }
        }]

        let tableProps = {
            columns,
            dataSource: data,
            pagination: false,
            bordered: true
        }

        let formProps = {
            record: formRecord,
            visible,
            columns: [{
                name: 'id',
                dataIndex: 'id',
                formItem: {
                    type: 'hidden'
                }
            }].concat(columns),
            title: '填写备注',
            modalOpts: { width: 700 },
            onCancel: () => this.setState({ visible: false, formRecord: null }),
            onSubmit: values => this._submit(values)
        }
        let sty = { marginBottom: 15, marginRight: 15, width: 90 }
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <CounselingHeader record={record} />
                <WizCard title='主要岗位人员情况'>
                    <WizButton type='primary' disabled={processContentState === 1} style={sty} onClick={() => this._onBtn('renew')}>{'更新'}</WizButton>
                    <WizButton type='primary' disabled={processContentState === 1 || !(data && data.length > 0)} style={sty} onClick={() => this._onBtn('confirm')}>{'达标确认'}</WizButton>
                    <WizButton disabled={!(data && data.length > 0)} style={sty} onClick={() => this._onBtn('export')}>{'导出'}</WizButton>
                    <WizModalForm {...formProps} />
                    <Table {...tableProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId } = findParamRecord(ownProps.history)
    const list = modelUtils.getModelEntity(counselingProcess, 'postPersonnel@' + processContentId)
    const renew = modelUtils.getModelEntity(counselingProcess, 'renewPostPersonnel@' + processContentId)
    const writeMark = modelUtils.getModelEntity(counselingProcess, 'writeMark@' + processContentId)
    const confirm = modelUtils.getModelEntity(counselingProcess, 'confirmMainPerson@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        list,
        renew,
        writeMark,
        confirm,
        ...loading
    }
}

export default connect(mapStateToProps)(PostPersonnel)


